import { Component, Input } from '@angular/core';
import { ButtonLevel, ButtonStyle, ButtonTarget, ButtonType } from '@challenger6/vm-pattern-library/button';
@Component({
  selector: 'vm-refer-a-friend',
  templateUrl: './vm-refer-a-friend.component.html',
  styleUrls: ['./vm-refer-a-friend.component.scss'],
})
export class VmReferAFriendComponent {
  ButtonType = ButtonType;
  ButtonStyle = ButtonStyle;
  ButtonLevel = ButtonLevel;
  @Input() optionHeader: string;
  @Input() optionSubHeader: string;
  @Input() buttonText: string;
  @Input() buttonLink: string;
  @Input() buttonTarget: ButtonTarget;
  @Input() imageUrl: string;

  constructor() {}
}
